module.exports = __webpack_public_path__ + "img/mc2.23a6ed1f.png";